import { NgModule } from "@angular/core";
import { LoggerService } from "./logger/logger.service";

@NgModule({
  providers: [LoggerService],
})
export class LoggerModule {}



// WEBPACK FOOTER //
// ./src/app/modules/logger.module.ts